package one.healthium.common.serializers

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

class SafeFloatSerializer : KSerializer<Float> {
    override val descriptor: SerialDescriptor
        get() = PrimitiveSerialDescriptor("SafeFloat", PrimitiveKind.FLOAT)

    override fun deserialize(decoder: Decoder): Float {
        return decoder.decodeFloat().let {
            if (it.isNaN() || it.isInfinite()) 0f else it
        }
    }

    override fun serialize(encoder: Encoder, value: Float) {
        encoder.encodeFloat(value)
    }
}